export default function () {
  return {
    user_role: "admin",
    permissions: [],
    mode: "",
    display: "title",
    update_mode: "all",
    locale: "",
    target: "",
    campaign_id: "",
    parameters: "",
    complete_action: "notify",
    country: "FR",
    account_name: "Company name",
    account_ids: undefined,
    ipsos_subsample_id: undefined,
    campaigns_tab_name: "Campaigns",
    creatives_tab_name: "Creatives",
    budgets_tab_name: "Budget",
    monitoring_tab_name: "Monitoring",
    batch_size: 100,
  };
}
